import {Injectable} from '@angular/core';
import {GlobalConstantsComponent} from '../../shared/global-constants/global-constants.component';
import {HttpClient} from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class WebinarService {

  private apiUrl = GlobalConstantsComponent.apiURL;

  constructor(
    private http: HttpClient,
  ) { }


  // Met à jour les informations particulières d'un webinar (titre en français, description en français, couverture, tags, etc...)
  updateInfos(data) {
    return this.http.post(this.apiUrl+ 'care/' + 'webinar/update', data)
  }

  getAllWebinars() {
    return this.http.get(`${this.apiUrl}webinar/all`) as any;
  }



}
